import React from "react";
import { isExpiryDay, expiryOf } from "./expiry";

/* ===== TradeCards — mobile card view of a trade log =====
   Rendered instead of the table below 640px (CSS-switched via .tl-cards /
   .tl-table-wrap). Tap a card for the full TradeDrawer; Exit button kept for
   open trades so no functionality is lost on mobile. */

function pnlOf(t, livePremiums) {
  if (t.status === "OPEN" && livePremiums && livePremiums[t.tradingsymbol] && t.entryPremium) {
    const q = t.remainingQty != null ? t.remainingQty : (t.qty || 0);
    return (t.trailExitPnl || 0) + Math.round((livePremiums[t.tradingsymbol] - t.entryPremium) * q);
  }
  return t.netPnl != null ? t.netPnl : t.grossPnl;
}

export default function TradeCards({ trades, livePremiums, onSelect, onExit }) {
  return (
    <div className="tl-cards">
      {trades.map(t => {
        const pnl = pnlOf(t, livePremiums);
        const open = t.status === "OPEN";
        const live = open && livePremiums && livePremiums[t.tradingsymbol];
        return (
          <div key={t.id} onClick={() => onSelect && onSelect(t)}
            style={{
              background: "var(--panel)", border: `1px solid ${open ? "#f59e0b55" : "var(--border)"}`,
              borderRadius: 10, padding: "10px 12px", marginBottom: 8, cursor: "pointer",
            }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <span className={`signal-badge ${t.type === "SHORT" ? "badge-short" : "badge-long"}`}>{t.type}</span>
              <span style={{ fontWeight: 700, color: "var(--text)" }}>{t.signalType} {t.strike}</span>
              {Array.isArray(t.aiReviews) && t.aiReviews.some(r => r.verdict === "EXIT") && <span title="AI suggested exit (advisory)">🤖</span>}
              {isExpiryDay(t) && <span title="Entered on its contract\u2019s expiry day (0DTE)" style={{ fontSize: 9, fontWeight: 700, color: "var(--warn-text)", border: "1px solid var(--warn-text)", borderRadius: 3, padding: "0 3px" }}>EXP</span>}
              {t.fibLevel && <span className="fib-badge">{t.fibLevel}</span>}
              <span style={{ marginLeft: "auto", fontSize: 15, fontWeight: 700 }}
                className={pnl != null ? (pnl >= 0 ? "positive" : "negative") : ""}>
                {pnl != null ? `${pnl >= 0 ? "+" : "-"}₹${Math.abs(pnl).toLocaleString("en-IN")}` : "—"}
              </span>
            </div>
            <div style={{ display: "flex", gap: 10, fontSize: 11, color: "var(--text-muted)", marginTop: 6, flexWrap: "wrap" }}>
              <span>{new Date(t.time).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: false })}</span>
              {t.exitTime && <span>→ exit {new Date(t.exitTime).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: false })}</span>}
              <span>{t.index}</span>
              <span>{t.qty} qty</span>
              {expiryOf(t) && <span title="Contract expiry">exp {expiryOf(t).slice(5)}</span>}
              <span className={open ? "positive" : ""} style={open ? { color: "#f59e0b", fontWeight: 700 } : {}}>
                {open ? "OPEN" : `${t.status}${t.exitReason ? ` · ${t.exitReason}` : ""}`}
              </span>
            </div>
            <div style={{ display: "flex", gap: 12, fontSize: 11.5, color: "var(--text-dim)", marginTop: 6, flexWrap: "wrap", alignItems: "center" }}>
              <span>Entry <b>{t.entry != null ? t.entry.toFixed(1) : "-"}</b></span>
              <span>SL <b style={{ color: "var(--neg)" }}>{t.sl != null ? t.sl.toFixed(1) : "-"}</b></span>
              <span>Tgt <b style={{ color: "var(--pos-text)" }}>{t.target != null ? t.target.toFixed(1) : "-"}</b></span>
              <span>Prem <b>₹{t.entryPremium != null ? t.entryPremium.toFixed(1) : "-"}</b>
                {" → "}
                <b>{live ? `₹${livePremiums[t.tradingsymbol].toFixed(1)}` : t.exitPremium != null ? `₹${t.exitPremium.toFixed(1)}` : "-"}</b>
              </span>
              {open && onExit && (
                <button className="btn btn-sm btn-danger" style={{ marginLeft: "auto", fontSize: 11, padding: "4px 12px" }}
                  onClick={(e) => { e.stopPropagation(); onExit(t); }}>Exit</button>
              )}
            </div>
            {t.trailExitDone && (
              <div style={{ fontSize: 10.5, color: "var(--info-soft)", marginTop: 5 }}>
                booked {t.trailExitQty} @ ₹{t.trailExitPremium}
                {t.trailExitPnl != null && <b className={t.trailExitPnl >= 0 ? "positive" : "negative"}> {t.trailExitPnl >= 0 ? "+" : ""}₹{t.trailExitPnl.toLocaleString("en-IN")}</b>}
                {t.remainingQty != null && <> · {t.remainingQty} running</>}
              </div>
            )}
          </div>
        );
      })}
      {!trades.length && <div style={{ color: "var(--text-muted)", fontSize: 12, padding: 8 }}>No trades for the selected filters.</div>}
    </div>
  );
}
